import Typography from '@mui/material/Typography'

const TextBody = props => {
  const {
    variant = 'subtitle',
    fontWeight,
    fontSize = '',
    children,
    margin = 0,
    cursor = 'default',
    ...rest
  } = props

  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight: fontWeight || 500,
        margin,
        fontSize: fontSize,
        cursor: cursor
      }}
      {...rest}
    >
      {children}
    </Typography>
  )
}
export default TextBody
